import { createAvatarSelectionController } from "./utils/avatar-selection-controller";
import { AVATAR_SELECTION_REQUESTED, requestAvatarSelection } from "./utils/avatar-selection-events";
import { resolveAvatarFallback } from "./utils/avatar-deletion";
import { getAuthHeaders } from "./utils/getToken";
import { getRuntimeModeratorGrant } from "./utils/dashboard-bridge";
import {
  getCurrentHubId,
  updateVRHudPresenceCount,
  updateSceneCopresentState,
  createHubChannelParams,
  isLockedDownDemoRoom
} from "./utils/hub-utils";
import "./utils/debug-log";
import configs from "./utils/configs";
import { setRuntimeDiagnosticsApiBase } from "./utils/runtime-diagnostics";
import { applyRoomDeploymentSelection } from "./utils/platform-room-api";
// import "./assets/stylesheets/fonts.scss"
import "./utils/theme";

import "core-js/stable";
import "regenerator-runtime/runtime";

import "./react-components/styles/global.scss";
import "./assets/stylesheets/globals.scss";
import "./assets/stylesheets/hub.scss";
import loadingEnvironment from "./assets/models/LoadingEnvironment.glb";

import "aframe";
import "./utils/aframe-overrides";

// A-Frame hardcodes THREE.Cache.enabled = true
// But we don't want to use THREE.Cache because
// web browser cache should work well.
// So we disable it here.
import * as THREE from "three";
THREE.Cache.enabled = false;
THREE.Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;

import "./utils/logging";
import { withIdleDetectionSuspendedUntilForeground } from "./utils/idle-detection-suspender";
import { patchWebGLRenderingContext } from "./utils/webgl";
patchWebGLRenderingContext();

import "networked-aframe/src/index";
import "webrtc-adapter";
import { detectOS, detect } from "detect-browser";
import {
  getReticulumFetchUrl,
  getReticulumMeta,
  migrateChannelToSocket,
  connectToReticulum,
  denoisePresence,
  presenceEventsForHub,
  tryGetMatchingMeta
} from "./utils/phoenix-utils";
import { Presence } from "phoenix";
import { emitter } from "./emitter";
import "./phoenix-adapter";

import nextTick from "./utils/next-tick";
import { addAnimationComponents } from "./utils/animation";
import Cookies from "js-cookie";
import {
  DIALOG_CHAT_MESSAGE_CREATED,
  DIALOG_CONNECTION_ERROR_FATAL,
  DIALOG_CONNECTION_CONNECTED,
  DIALOG_CONNECTION_STATE,
  DIALOG_CONNECTION_STATE_CHANGED
} from "./naf-dialog-adapter";
import { resolveDialogEndpoint } from "./utils/dialog-endpoint-utils";
import {
  resolveRtcSfuDialogEndpoint,
  resolveRtcSfuOrchestratorUrl,
  shouldUseRtcSfuOrchestrator
} from "./utils/rtc-sfu-orchestrator-utils";
import { getRtcSfuConnectionNotification } from "./utils/rtc-sfu-connection-notification-utils";
import {
  logRtcSfuRecovery,
  summarizeRtcSfuEndpoint,
  summarizeRtcSfuError,
  summarizeRtcSfuRoomSession
} from "./utils/rtc-sfu-recovery-debug";
import {
  hasDialogConnectedForCurrentRoom,
  markDialogConnectedForCurrentRoom,
  shouldShowDialogConnectErrorScreen
} from "./utils/dialog-connection-state-utils";
import "./change-hub";

import "./components/scene-components";
import "./components/mute-mic";
import "./components/bone-mute-state-indicator";
import "./components/bone-visibility";
import "./components/fader";
import "./components/in-world-hud";
import "./components/emoji";
// import "./components/emoji-hud";
import "./components/virtual-gamepad-controls";
import "./components/ik-controller";
import "./components/ik-custom-controller";
import "./components/hand-controls2";
import "./components/hoverable-visuals";
import "./components/hover-visuals";
import "./components/offset-relative-to";
import "./components/player-info";
import "./components/name-tag";
import "./components/debug";
import "./components/hand-poses";
import "./components/hud-controller";
import "./components/freeze-controller";
import "./components/icon-button";
import "./components/text-button";
import "./components/block-button";
import "./components/mute-button";
import "./components/kick-button";
import "./components/close-vr-notice-button";
import "./components/leave-room-button";
import "./components/visible-if-permitted";
import "./components/visibility-on-content-types";
import "./components/hide-when-pinned-and-forbidden";
import "./components/hide-when-artwork-dimensions";
import "./components/visibility-while-frozen";
import "./components/stats-plus";
import "./components/networked-avatar";
import "./components/media-video";
import "./components/media-pdf";
import "./components/media-image";
import "./components/avatar-volume-controls";
import "./components/pinch-to-move";
import "./components/pitch-yaw-rotator";
import "./components/position-at-border";
import "./components/pinnable";
import "./components/lockeable";
import "./components/pin-networked-object-button";
import "./components/mirror-media-button";
import "./components/close-mirrored-media-button";
import "./components/drop-object-button";
import "./components/camera-focus-button";
import "./components/unmute-video-button";
import "./components/visible-to-owner";
import "./components/emit-state-change";
import "./components/action-to-event";
import "./components/action-to-remove";
import "./components/emit-scene-event-on-remove";
import "./components/follow-in-fov";
import "./components/clone-media-button";
import "./components/mint-nft-button";
import "./components/waypoint-icon";
import "./components/enable-on-proximity";
import "./components/ai-proximity-audio";
import "./components/aux-extreme-distance";
import "./components/artwork";
import "./components/artwork-toggler-menu";
import "./components/artwork-frame";
import "./components/artwork-medium";
import "./components/artwork-qr";
import "./components/artwork-info";
import "./components/link-sequence";
import "./components/init-camera-distance";
import "./components/artwork-pivot";
import "./components/open-media-button";
import "./components/change-hub-when-near";
import "./components/refresh-media-button";
import "./components/tweet-media-button";
import "./components/remix-avatar-button";
import "./components/transform-object-button";
import "./components/scale-button";
import "./components/hover-menu";
import "./components/disable-frustum-culling";
import "./components/teleporter";
import "./components/track-pose";
import "./components/replay";
import "./components/visibility-by-path";
import "./components/tags";
import "./components/periodic-full-syncs";
import "./components/inspect-button";
import "./components/inspect-pivot-child-selector";
import "./components/inspect-pivot-offset-from-camera";
import "./components/optional-alternative-to-not-hide";
import "./components/avatar-audio-source";
import "./components/avatar-inspect-collider";
import "./components/video-texture-target";
import "./components/mirror";
import "./components/open-upload-form";
import "./components/avatar-animation.js";
import "./components/background-transition";
import "./components/external-glb-importer";
import "./components/npc-avatar";
import "./components/ai-agent";
import "./components/primitive-shape";
import "./components/object-to-aframe-observer";
import "./components/transform-listener";
import "./components/runtime-settings";

import ReactDOM from "react-dom";
import React from "react";
import { Router, Route } from "react-router-dom";
import { createBrowserHistory, createMemoryHistory } from "history";
import { pushHistoryState } from "./utils/history";
import UIRoot from "./react-components/ui-root";
import { ExitedRoomScreenContainer } from "./react-components/room/ExitedRoomScreenContainer";
import AuthChannel from "./utils/auth-channel";
import HubChannel from "./utils/hub-channel";
import LinkChannel from "./utils/link-channel";
import { disableiOSZoom } from "./utils/disable-ios-zoom";
import { proxiedUrlFor } from "./utils/media-url-utils";
import { traverseMeshesAndAddShapes } from "./utils/physics-utils";
import { handleExitTo2DInterstitial, exit2DInterstitialAndEnterVR } from "./utils/vr-interstitial";
import { fetchAvatar, resolveAvatarSrcWithFallback } from "./utils/avatar-utils.js";
import MessageDispatch from "./message-dispatch";
import SceneEntryManager from "./scene-entry-manager";
import Subscriptions from "./subscriptions";
import { createInWorldLogMessage } from "./react-components/chat-message";
import { fetchRandomPlatformPickAvatarId } from "./utils/identity.js";
import { buildDialogChatPresenceEntry } from "./utils/dialog-chat-message";

import "./systems/nav";
import "./systems/frame-scheduler";
import "./systems/personal-space-bubble";
import "./systems/app-mode";
import "./systems/permissions";
import "./systems/exit-on-blur";
import "./systems/auto-pixel-ratio";
import "./systems/idle-detector";
import "./systems/pen-tools";
import "./systems/userinput/userinput";
import "./systems/userinput/userinput-debug";
import "./systems/ui-hotkeys";
import "./systems/tips";
import "./systems/interactions";
import "./systems/hubs-systems";
import "./systems/capture-system";
import "./systems/listed-media";
import "./systems/linked-media";
import "./systems/audio-debug-system";
import "./systems/audio-gain-system";
import "./systems/scripting-system";
import "./systems/npc-audio-system";
import "./gltf-component-mappings";
import "./systems/ar-camera-system";
import "./systems/teleporter-system";
import "./systems/freeze-menu-system";
import "./systems/camera-movement-detector";
import "./systems/drawing-menu-system";

import { App, getScene } from "./app";
import MediaDevicesManager from "./utils/media-devices-manager";
import PinningHelper from "./utils/pinning-helper";
import LockHelper from "./utils/lock-helper";
import { sleep } from "./utils/async-utils";
import { platformUnsupported } from "./support";
import { renderAsEntity } from "./utils/jsx-entity";
import { VideoMenuPrefab } from "./prefabs/video-menu";
import { ObjectMenuPrefab } from "./prefabs/object-menu";
import { LinkHoverMenuPrefab } from "./prefabs/link-hover-menu";
import { PDFMenuPrefab } from "./prefabs/pdf-menu";
import { loadWaypointPreviewModel, WaypointPreview } from "./prefabs/waypoint-preview";
import { loadAnimationModel, animationModel } from "./prefabs/animation";
import { preload } from "./utils/preload";
import { TokenProvider } from "./react-components/TokenProvider";
import { setupWakeLock } from "./utils/wake-lock";

window.APP = new App();
renderAsEntity(APP.world, VideoMenuPrefab());
renderAsEntity(APP.world, VideoMenuPrefab());
function addToScene(entityDef, visible) {
  return getScene().then(scene => {
    const eid = renderAsEntity(APP.world, entityDef);
    const obj = APP.world.eid2obj.get(eid);
    scene.add(obj);
    obj.visible = !!visible;
  });
}
preload(addToScene(PDFMenuPrefab(), false));
preload(addToScene(ObjectMenuPrefab(), false));
preload(addToScene(ObjectMenuPrefab(), false));
preload(addToScene(LinkHoverMenuPrefab(), false));
preload(loadWaypointPreviewModel().then(() => addToScene(WaypointPreview(), false)));
preload(loadAnimationModel().then(() => addToScene(animationModel(), false)));

const store = window.APP.store;
setRuntimeDiagnosticsApiBase(configs.CUSTOM_API_URL);
store.update({ preferences: { shouldPromptForRefresh: false } }); // Clear flag that prompts for refresh from preference screen
const mediaSearchStore = window.APP.mediaSearchStore;
const OAUTH_FLOW_PERMS_TOKEN_KEY = "ret-oauth-flow-perms-token";
const NOISY_OCCUPANT_COUNT = 30; // Above this # of occupants, we stop posting join/leaves/renames

const qs = new URLSearchParams(location.search);
const isMobile = AFRAME.utils.device.isMobile();
const isMobileVR = AFRAME.utils.device.isMobileVR();
const isEmbed = window.self !== window.top;

if (isEmbed && !qs.get("embed_token")) {
  // Should be covered by X-Frame-Options, but just in case.
  throw new Error("no embed token");
}

const creatorAssignmentToken = qs.get("creator_assignment_token");

const hubId = getCurrentHubId();

if (creatorAssignmentToken) {
  store.update({ creatorAssignmentTokens: [{ hubId, creatorAssignmentToken }] });

  // Remove the creator_assignment_token queryString from the URL so that it doesn't get passed to other hubs
  window.history.replaceState(
    {},
    document.title,
    window.location.pathname + window.location.search.replace(/&?creator_assignment_token=[^&]+/, "")
  );
}

import "./components/owned-object-limiter";
import "./components/owned-object-cleanup-timeout";
import "./components/set-unowned-body-kinematic";
import "./components/scalable-when-grabbed";
import "./components/networked-counter";
import "./components/event-repeater";
import "./components/set-yxz-order";

import "./components/cursor-controller";

import "./components/tools/pen";
import "./components/tools/pen-laser";
import "./components/tools/networked-drawing";
import "./components/tools/drawing-manager";

import "./components/body-helper";
import "./components/shape-helper";
import "./components/layout";
import "./components/show-menu";
import "./components/local-menu";
import "./components/persistable";
import "./components/ground-plane";
import "./components/spawner";
import "./components/asset-metadata";

import registerNetworkSchemas from "./network-schemas";
import registerTelemetry from "./telemetry";

import { getAvailableVREntryTypes, VR_DEVICE_AVAILABILITY, ONLY_SCREEN_AVAILABLE } from "./utils/vr-caps-detect";
import detectConcurrentLoad from "./utils/concurrent-load-detector";

import qsTruthy from "./utils/qs_truthy";
import { WrappedIntlProvider } from "./react-components/wrapped-intl-provider";
import { ExitReason } from "./react-components/room/ExitedRoomScreen";
import { OAuthScreenContainer } from "./react-components/auth/OAuthScreenContainer";
import { SignInMessages } from "./react-components/auth/SignInModal";
import { ThemeProvider } from "./react-components/styles/theme";
import { getRoomEntryAccessState, requiresLegacyEventEntryGate } from "./utils/room-entry-access";
import { fetchEvent, getEventAdmission } from "./utils/event-service";
import { eventHasConcluded, eventRoomContext, getEndTime, getEventSession } from "./utils/events-utils";
import { LogMessageType } from "./utils/messages";
import dashboardChannelSingleton from "./utils/dashboard-channel-singleton";
import { startLocalBridgeRedirectIfHinted } from "./utils/local-bridge-rehydration";
import "./load-media-on-paste-or-drop";
import { swapActiveScene } from "./bit-systems/scene-loading";
import { localClientID, setLocalClientID } from "./bit-systems/networking";
import { listenForNetworkMessages } from "./utils/listen-for-network-messages";
import { exposeBitECSDebugHelpers } from "./bitecs-debug-helpers";
import { loadLegacyRoomObjects } from "./utils/load-legacy-room-objects";
import { loadSavedEntityStates } from "./utils/entity-state-utils";
import getAuthUser from "./utils/get-auth-user";
import { captureScreenshot } from "./utils/generate-screenshot";
import SyncNAFHelper from "./sync-naf-helper";
import configManager from "./singleton/ConfigManager";
import { canEnterFromRoomSession } from "./utils/rtc-sfu-room-session";
import { resolveRoomResourceLimits } from "./utils/room-resource-limits-utils";
import { RuntimeFluentProvider } from "./utils/fluent-theme";
import "./utils/fluent-set-fonts";
import MediaDeviceManagerPermissions from "./singleton/MediaDeviceManagerPermissions";
import notificationsCenter from "./singleton/NotificationsCenter";
import { IntlInitializer } from "./react-components/IntlInitializer";

const PHOENIX_RELIABLE_NAF = "phx-reliable";
NAF.options.firstSyncSource = PHOENIX_RELIABLE_NAF;
NAF.options.syncSource = PHOENIX_RELIABLE_NAF;

let isOAuthModal = false;

// OAuth popup handler
// TODO: Replace with a new oauth callback route that has this postMessage script.
try {
  if (window.opener && window.opener.doingTwitterOAuth) {
    window.opener.postMessage("oauth-successful");
    isOAuthModal = true;
    window.close();
  }
} catch (e) {
  console.error("Exception in oauth processing code", e);
}

const isBotMode = qsTruthy("bot");
const isTelemetryDisabled = qsTruthy("disable_telemetry");
const isDebug = qsTruthy("debug");

document.addEventListener("DOMContentLoaded", () => {
  if (!isBotMode && !isTelemetryDisabled) {
    registerTelemetry("/hub", "Room Landing Page");
    registerTelemetry(window.location.pathname, document.title);
  }
});

disableiOSZoom();

if (!isOAuthModal) {
  detectConcurrentLoad();
}

if (qsTruthy("ecsDebug")) {
  exposeBitECSDebugHelpers();
}

function setupLobbyCamera() {
  const camera = document.getElementById("scene-preview-node");
  const previewCamera = document.getElementById("environment-scene").object3D.getObjectByName("scene-preview-camera");

  if (previewCamera) {
    camera.object3D.position.copy(previewCamera.position);
    camera.object3D.rotation.copy(previewCamera.rotation);
    camera.object3D.rotation.reorder("YXZ");
  } else {
    const cameraPos = camera.object3D.position;
    camera.object3D.position.set(cameraPos.x, 2.5, cameraPos.z);
  }

  camera.object3D.matrixNeedsUpdate = true;
  camera.removeAttribute("scene-preview-camera");
  camera.setAttribute("scene-preview-camera", "positionOnly: true; duration: 60");
}

let uiProps = {};

// Hub ID and slug are the basename
let routerBaseName = document.location.pathname.split("/").slice(0, 2).join("/");

if (document.location.pathname.includes("hub.html")) {
  routerBaseName = "/";
}

// when loading the client as a "default room" on the homepage, use MemoryHistory since exposing all the client paths at the root is undesirable
const history = routerBaseName === "/" ? createMemoryHistory() : createBrowserHistory({ basename: routerBaseName });
window.APP.history = history;

const qsVREntryType = qs.get("vr_entry_type");

function mountUI(props = {}) {
  const scene = document.querySelector("a-scene");
  const disableAutoExitOnIdle =
    qsTruthy("allow_idle") || (process.env.NODE_ENV === "development" && !qs.get("idle_timeout"));
  const forcedVREntryType = qsVREntryType;

  ReactDOM.render(
    <WrappedIntlProvider>
      <IntlInitializer>
        <RuntimeFluentProvider>
          <ThemeProvider store={store}>
            <Router history={history}>
              <TokenProvider entered={Boolean(scene?.is("entered"))} />
              <Route
                render={routeProps =>
                  props.showOAuthScreen ? (
                    <OAuthScreenContainer oauthInfo={props.oauthInfo} />
                  ) : props.roomUnavailableReason ? (
                    <ExitedRoomScreenContainer reason={props.roomUnavailableReason} leaveRoomUrl={props.leaveRoomUrl} />
                  ) : (
                    <UIRoot
                      {...{
                        scene,
                        isBotMode,
                        disableAutoExitOnIdle,
                        forcedVREntryType,
                        store,
                        mediaSearchStore,
                        ...props,
                        ...routeProps
                      }}
                    />
                  )
                }
              />
            </Router>
          </ThemeProvider>
        </RuntimeFluentProvider>
      </IntlInitializer>
    </WrappedIntlProvider>,
    document.getElementById("ui-root")
  );
}

export function remountUI(props) {
  uiProps = { ...uiProps, ...props };
  mountUI(uiProps);
}

export async function getSceneUrlForHub(hub) {
  let sceneUrl;
  let isLegacyBundle; // Deprecated
  if (hub.scene) {
    isLegacyBundle = false;
    sceneUrl = hub.scene.model_url;
  } else if (hub.scene === null) {
    // delisted/removed scene
    sceneUrl = loadingEnvironment;
  } else {
    const defaultSpaceTopic = hub.topics[0];
    const glbAsset = defaultSpaceTopic.assets.find(a => a.asset_type === "glb");
    const bundleAsset = defaultSpaceTopic.assets.find(a => a.asset_type === "gltf_bundle");
    sceneUrl = (glbAsset || bundleAsset).src || loadingEnvironment;
    const hasExtension = /\.gltf/i.test(sceneUrl) || /\.glb/i.test(sceneUrl);
    isLegacyBundle = !(glbAsset || hasExtension);
  }

  if (qsTruthy("debugLocalScene") && sceneUrl?.startsWith("blob:")) {
    // we skip doing this if you haven't entered because refreshing the page will invalidate blob urls and break loading
    sceneUrl = document.querySelector("a-scene").is("entered") ? sceneUrl : loadingEnvironment;
  } else if (isLegacyBundle) {
    // Deprecated
    const res = await fetch(sceneUrl);
    const data = await res.json();
    const baseURL = new URL(THREE.LoaderUtils.extractUrlBase(sceneUrl), window.location.href);
    sceneUrl = new URL(data.assets[0].src, baseURL).href;
  } else {
    sceneUrl = proxiedUrlFor(sceneUrl);
  }
  return sceneUrl;
}

function handleEnvironmentTransition(environmentEl, environmentScene, sceneEl) {
  const finishTransition = forceTransition => {
    if (sceneEl.is("entered") || forceTransition) {
      environmentEl.setAttribute("visible", true);
      THREE.Cache.clear();
      const waypointSystem = sceneEl.systems["hubs-systems"].waypointSystem;
      waypointSystem.releaseAnyOccupiedWaypoints();

      waypointSystem.moveToSpawnPoint();
      sceneEl.emit("portaling-complete");
      sceneEl.emit("screenshot-complete");
    }
  };

  // Create an interval to find the media image element
  let tries = 0;
  const interval = setInterval(() => {
    const mediaImageEl = [...environmentEl.querySelectorAll("[media-image][networked]")].find(
      el => el.components["media-image"].data.projection === "360-equirectangular"
    );

    if (mediaImageEl) {
      mediaImageEl.setAttribute("background-transition", {
        environmentEl: environmentEl
      });
      if (mediaImageEl.components["media-image"] && mediaImageEl.components["media-image"].loaded) {
        setTimeout(() => {
          mediaImageEl.components["background-transition"].transition();
          finishTransition(true);
        }, 2000);
      }

      mediaImageEl.addEventListener("media-loaded", () => {
        setTimeout(() => {
          mediaImageEl.components["background-transition"].transition();

          finishTransition(true);
        }, 2000);
      });

      clearInterval(interval);
    }

    if (tries > 100) {
      clearInterval(interval);
      environmentScene.removeChild(environmentScene.childNodes[0]);
      finishTransition();
    }

    tries += 1;
  }, 100);
}

export async function updateEnvironmentForHub(
  hub,
  entryManager,
  smoothTransition = false,
  { isCurrent = () => true, signal } = {}
) {
  const environmentState = { ready: false };
  APP.environmentTransition = environmentState;
  configManager.reset();
  const sceneUrl = await getSceneUrlForHub(hub);
  if (!isCurrent()) return;

  if (qsTruthy("newLoader")) {
    configManager.addConfig({});
    swapActiveScene(APP.world, sceneUrl);
    environmentState.ready = true;
    return;
  }

  const environmentScene = document.querySelector("#environment-scene");
  const sceneEl = document.querySelector("a-scene");

  const envSystem = sceneEl.systems["hubs-systems"].environmentSystem;
  let resolveEnvironmentConfig;
  let environmentSettled = false;
  const environmentConfigReady = new Promise(resolve => {
    resolveEnvironmentConfig = () => {
      if (environmentSettled) return;
      environmentSettled = true;
      environmentState.ready = isCurrent();
      resolve();
    };
  });

  const listeners = new Set();
  const listen = (target, event, callback, options) => {
    const binding = { target, event, callback, options };
    const guarded = (...args) => {
      if (!isCurrent()) return;
      const modelEvent = args[0];
      const loader = target.components?.["gltf-model-plus"];
      if (modelEvent?.target && modelEvent.target !== target) return;
      if (modelEvent?.detail?.src && modelEvent.detail.src !== (loader?.lastSrc || loader?.data.src)) return;
      // Ignore stale/child events without consuming this listener's one shot.
      if (options?.once) {
        target.removeEventListener(event, guarded, options);
        listeners.delete(binding);
      }
      callback(...args);
    };
    binding.guarded = guarded;
    listeners.add(binding);
    target.addEventListener(event, guarded, { ...options, once: false });
  };
  const unlisten = (target, event, callback) => {
    for (const binding of listeners) {
      if (binding.target === target && binding.event === event && binding.callback === callback) {
        target.removeEventListener(event, binding.guarded, binding.options);
        listeners.delete(binding);
      }
    }
  };
  signal?.addEventListener(
    "abort",
    () => {
      for (const { target, event, guarded, options } of listeners) target.removeEventListener(event, guarded, options);
      listeners.clear();
      resolveEnvironmentConfig();
    },
    { once: true }
  );

  let environmentEl = null;
  let hasLoadedSceneFallback = false;
  const sceneErrorHandler = () => {
    const currentSceneSrc = environmentEl?.components?.["gltf-model-plus"]?.data?.src;

    if (!hasLoadedSceneFallback && currentSceneSrc !== loadingEnvironment) {
      hasLoadedSceneFallback = true;
      console.warn("Failed to load scene environment, falling back to loading environment", {
        sceneUrl,
        currentSceneSrc
      });
      listen(environmentEl, "model-error", sceneErrorHandler, { once: true });
      environmentEl.setAttribute("gltf-model-plus", { src: loadingEnvironment, useCache: false, inflate: true });
      return;
    }

    resolveEnvironmentConfig();
    remountUI({ roomUnavailableReason: ExitReason.sceneError });
    entryManager.exitScene();
  };

  if (environmentScene.childNodes.length === 0) {
    environmentEl = document.createElement("a-entity");

    if (environmentScene.childNodes.length > 0) {
      sceneEl.emit("portaling-initiated");
    }

    THREE.Cache.clear();

    listen(
      environmentEl,
      "model-loaded",
      () => {
        unlisten(environmentEl, "model-error", sceneErrorHandler);

        // Show the canvas once the model has loaded
        document.querySelector(".a-canvas").classList.remove("a-hidden");

        sceneEl.addState("visible");

        envSystem.updateEnvironment(environmentEl);
        resolveEnvironmentConfig();

        //TODO: check if the environment was made with spoke to determine if a shape should be added
        traverseMeshesAndAddShapes(environmentEl);

        if (environmentScene.childNodes.length > 1) {
          handleEnvironmentTransition(environmentEl, environmentScene, sceneEl);
        }
      },
      { once: true }
    );

    listen(environmentEl, "model-error", sceneErrorHandler, { once: true });

    environmentEl.setAttribute("gltf-model-plus", { src: sceneUrl, useCache: false, inflate: true });

    if (environmentScene.childNodes.length > 0) {
      environmentEl.setAttribute("visible", false);
    }

    environmentScene.appendChild(environmentEl);
  } else if (smoothTransition) {
    // Change environment
    environmentEl = environmentScene.childNodes[0];

    // Clear the three.js image cache and load the loading environment before switching to the new one.
    THREE.Cache.clear();
    const waypointSystem = sceneEl.systems["hubs-systems"].waypointSystem;
    waypointSystem.releaseAnyOccupiedWaypoints();

    sceneEl.emit("portaling-initiated");

    const screenshot = captureScreenshot();
    sceneEl.emit("screenshot-load", screenshot);

    environmentEl.setAttribute("visible", false);

    listen(
      environmentEl,
      "model-loaded",
      () => {
        listen(
          environmentEl,
          "model-loaded",
          () => {
            const tourHandlers = document.querySelectorAll("[avatar-tour-handler]");

            unlisten(environmentEl, "model-error", sceneErrorHandler);

            envSystem.updateEnvironment(environmentEl);
            resolveEnvironmentConfig();

            tourHandlers.forEach(handler => {
              handler.components["avatar-tour-handler"].checkTour();
            });

            traverseMeshesAndAddShapes(environmentEl);

            // We've already entered, so move to new spawn point once new environment is loaded
            if (sceneEl.is("entered")) {
              waypointSystem.moveToSpawnPoint();
            }

            handleEnvironmentTransition(environmentEl, environmentScene, sceneEl);
          },
          { once: true }
        );

        // If we had a loop-animation component on the environment, we need to remove it
        // before loading a new model with gltf-model-plus, or else the component won't
        // find and play animations in the new scene.
        environmentEl.removeAttribute("loop-animation");

        sceneEl.emit("leaving_loading_environment");
        if (environmentEl.components["gltf-model-plus"].data.src === sceneUrl) {
          environmentEl.setAttribute("gltf-model-plus", { src: "" });
        }
        environmentEl.setAttribute("gltf-model-plus", { src: sceneUrl });
      },
      { once: true }
    );

    if (!sceneEl.is("entered")) {
      listen(environmentEl, "model-error", sceneErrorHandler, { once: true });
    }

    if (environmentEl.components["gltf-model-plus"].data.src === loadingEnvironment) {
      environmentEl.setAttribute("gltf-model-plus", { src: "" });
    }
    environmentEl.setAttribute("gltf-model-plus", { src: loadingEnvironment });
  } else {
    // Change environment
    environmentEl = environmentScene.childNodes[0];

    // Clear the three.js image cache and load the loading environment before switching to the new one.
    THREE.Cache.clear();
    const waypointSystem = sceneEl.systems["hubs-systems"].waypointSystem;
    waypointSystem.releaseAnyOccupiedWaypoints();

    listen(
      environmentEl,
      "model-loaded",
      () => {
        listen(
          environmentEl,
          "model-loaded",
          () => {
            unlisten(environmentEl, "model-error", sceneErrorHandler);

            envSystem.updateEnvironment(environmentEl);
            resolveEnvironmentConfig();

            traverseMeshesAndAddShapes(environmentEl);

            // We've already entered, so move to new spawn point once new environment is loaded
            if (sceneEl.is("entered")) {
              waypointSystem.moveToSpawnPoint();
            }

            const fader = document.getElementById("viewing-camera").components["fader"];

            // Add a slight delay before de-in to reduce hitching.
            setTimeout(() => {
              if (!isCurrent()) return;
              fader.fadeIn();
              sceneEl.emit("scene-loaded");
            }, 2000);
          },
          { once: true }
        );

        // If we had a loop-animation component on the environment, we need to remove it
        // before loading a new model with gltf-model-plus, or else the component won't
        // find and play animations in the new scene.
        environmentEl.removeAttribute("loop-animation");

        sceneEl.emit("leaving_loading_environment");
        if (environmentEl.components["gltf-model-plus"].data.src === sceneUrl) {
          environmentEl.setAttribute("gltf-model-plus", { src: "" });
        }
        environmentEl.setAttribute("gltf-model-plus", { src: sceneUrl });
      },
      { once: true }
    );

    if (!sceneEl.is("entered")) {
      listen(environmentEl, "model-error", sceneErrorHandler, { once: true });
    }

    if (environmentEl.components["gltf-model-plus"].data.src === loadingEnvironment) {
      environmentEl.setAttribute("gltf-model-plus", { src: "" });
    }
    environmentEl.setAttribute("gltf-model-plus", { src: loadingEnvironment });
  }

  return environmentConfigReady;
}

export async function updateUIForHub(hub) {
  remountUI({ hub, entryDisallowed: false });
}

let lastRtcSfuConnectionState = null;

export function updateRtcSfuConnectionState(state) {
  if (!state || state === lastRtcSfuConnectionState) {
    return;
  }

  lastRtcSfuConnectionState = state;
  logRtcSfuRecovery("ui:connection-state", { state });
  remountUI({
    dialogConnected: state === DIALOG_CONNECTION_STATE.CONNECTED,
    hasDialogConnectedOnce: state === DIALOG_CONNECTION_STATE.CONNECTED || hasDialogConnectedForCurrentRoom(APP),
    rtcSfuConnectionState: state === DIALOG_CONNECTION_STATE.CONNECTED ? null : state
  });

  const notification = getRtcSfuConnectionNotification(state);
  if (notification) {
    notificationsCenter[notification.level](notification.title, notification.body, { timeout: notification.timeout });
  }
}

function showDialogConnectErrorScreen(entryManager, reason = ExitReason.connectError) {
  remountUI({ roomUnavailableReason: reason });
  entryManager.exitScene();
}

async function getEventDataForEntryGate(hub) {
  const { eventSlug } = eventRoomContext(hub?.user_data);

  if (!eventSlug) {
    return null;
  }

  if (APP.eventData && (APP.eventDataSlug === eventSlug || APP.eventData.slug === eventSlug)) {
    return APP.eventData;
  }

  try {
    const eventData = await fetchEvent(eventSlug);

    if (eventData) {
      APP.eventData = eventData;
      APP.eventDataSlug = eventSlug;
    }

    return eventData;
  } catch (error) {
    console.warn("Failed to fetch event data for entry gate", error);
    return null;
  }
}

async function getRoomUnavailableReasonForEntry(hubChannel, hub, store) {
  const { eventId, eventSlug, roomRole, sessionSlug, visibility } = eventRoomContext(hub?.user_data);
  const eventData = await getEventDataForEntryGate(hub);
  const eventVisibility = eventData?.visibility;

  if (!requiresLegacyEventEntryGate({ eventId, roomRole, visibility, eventVisibility })) {
    return null;
  }

  if (eventData && roomRole === "lobby" && eventVisibility === "private") {
    const user = await getAuthUser(store, true);
    if (!user) return ExitReason.rsvpRequired;

    const admission = await getEventAdmission({ eventSlug });
    return admission?.admitted ? null : ExitReason.rsvpRequired;
  }

  const isInTheEvent = await hubChannel.isInTheEvent(hub);
  const eventGateData = eventData ? getEventSession(eventData, sessionSlug) || eventData : hub?.user_data;
  const { canAccessEvent } = getRoomEntryAccessState({
    slug: eventSlug,
    isInTheEvent,
    hasEventConcluded: eventHasConcluded(getEndTime(eventGateData))
  });

  if (!canAccessEvent) {
    return ExitReason.rsvpRequired;
  }

  const hasTicket = await hubChannel.hasTicket(hub);
  const hasRole = await hubChannel.hasRole(hub);

  if (!hasTicket || !hasRole) {
    const user = await getAuthUser(store, true);

    return user ? ExitReason.denied : ExitReason.signInRequired;
  }

  return null;
}

function handleRtcSfuConnectionStateChange(state, entryManager, scene) {
  if (state === DIALOG_CONNECTION_STATE.FAILED && shouldShowDialogConnectErrorScreen({ scene, state })) {
    showDialogConnectErrorScreen(entryManager);
    return;
  }

  updateRtcSfuConnectionState(state);
}

function onConnectionError(entryManager, connectError) {
  console.error("An error occurred while attempting to connect to networked scene:", connectError);
  const scene = document.querySelector("a-scene");

  if (!shouldShowDialogConnectErrorScreen({ scene })) {
    handleRtcSfuConnectionStateChange(DIALOG_CONNECTION_STATE.FAILED, entryManager, scene);
    return;
  }

  // hacky until we get return codes
  const isFull = connectError.msg && connectError.msg.match(/\bfull\b/i);
  showDialogConnectErrorScreen(entryManager, isFull ? ExitReason.full : ExitReason.connectError);
}

function summarizeDialogChatMessage(message = {}) {
  return {
    conversationType: message.conversationType,
    senderType: message.senderType,
    senderSessionId: message.senderSessionId,
    recipientSessionId: message.recipientSessionId,
    clientMessageId: message.clientMessageId,
    idempotencyKey: message.idempotencyKey,
    createdAt: message.createdAt,
    hasText: typeof message.text === "string",
    textLength: typeof message.text === "string" ? message.text.length : undefined,
    agentUuid: message.agentUuid,
    turnId: message.turnId
  };
}

async function resolveHubDialogEndpoint(
  hub,
  clientId,
  searchParams,
  { onStateChange = updateRtcSfuConnectionState, allocationGrant = null } = {}
) {
  const orchestratorUrl = resolveRtcSfuOrchestratorUrl({ searchParams, configUrl: configs.RTC_SFU_ORCHESTRATOR_URL });
  const useOrchestrator = shouldUseRtcSfuOrchestrator({ searchParams, orchestratorUrl });

  logRtcSfuRecovery("endpoint:resolve:start", {
    roomId: hub?.hub_id,
    clientId,
    orchestratorUrl,
    useOrchestrator,
    hasAllocationGrant: Boolean(allocationGrant),
    hasDialogOverride: Boolean(
      searchParams.get("dialog_url") || searchParams.get("dialog_host") || searchParams.get("dialog_port")
    )
  });

  if (!useOrchestrator) {
    const endpoint = resolveDialogEndpoint(hub, searchParams);
    logRtcSfuRecovery("endpoint:resolve:fallback-dialog", {
      reason: "orchestrator-disabled",
      endpoint: summarizeRtcSfuEndpoint(endpoint)
    });

    return endpoint;
  }

  if (!allocationGrant) {
    const endpoint = resolveDialogEndpoint(hub, searchParams);
    logRtcSfuRecovery("endpoint:resolve:fallback-dialog", {
      reason: "missing-allocation-grant",
      endpoint: summarizeRtcSfuEndpoint(endpoint)
    });

    return endpoint;
  }

  try {
    const endpoint = await resolveRtcSfuDialogEndpoint({
      hub,
      clientId,
      allocationGrant,
      searchParams,
      dashboardApiUrl: configs.CUSTOM_API_URL,
      orchestratorUrl,
      requestAllocationGrant: runtimeRoomId =>
        window.APP?.dashboardChannel?.platformRoomApi?.requestRuntimeAllocationGrant(runtimeRoomId),
      onStateChange
    });
    logRtcSfuRecovery("endpoint:resolve:orchestrator", { endpoint: summarizeRtcSfuEndpoint(endpoint) });

    return endpoint;
  } catch (err) {
    logRtcSfuRecovery("endpoint:resolve:error", {
      roomId: hub?.hub_id,
      error: summarizeRtcSfuError(err)
    });
    throw err;
  }
}

async function requestActiveRtcSfuRoomSession({ roomId, clientId }) {
  const requestRoomSession = window.APP?.dashboardChannel?.requestRtcSfuRoomSession;

  if (!requestRoomSession) {
    throw new Error("RTC SFU room session endpoint is not available.");
  }

  const currentRoomSession = APP.rtcSfuRoomSession;
  const reconnectSession =
    currentRoomSession?.roomId === roomId || currentRoomSession?.hubId === roomId ? currentRoomSession : null;

  logRtcSfuRecovery("room-session:request", {
    roomId,
    clientId,
    reconnectSession: summarizeRtcSfuRoomSession(reconnectSession)
  });

  let roomSession;

  try {
    roomSession = await requestRoomSession({
      roomId,
      clientId,
      reserve: true,
      roomSessionId: reconnectSession?.roomSessionId,
      reconnectToken: reconnectSession?.reconnectToken
    });
  } catch (err) {
    logRtcSfuRecovery("room-session:request-error", { roomId, error: summarizeRtcSfuError(err) });
    throw err;
  }

  if (!roomSession || !canEnterFromRoomSession(roomSession) || !roomSession.allocationGrant) {
    logRtcSfuRecovery("room-session:invalid", {
      roomId,
      session: summarizeRtcSfuRoomSession(roomSession)
    });
    throw new Error("RTC SFU room session did not include an allocation grant.");
  }

  logRtcSfuRecovery("room-session:response", {
    roomId,
    session: summarizeRtcSfuRoomSession(roomSession)
  });

  return roomSession;
}

function withResolvedRoomResourceLimits(roomSession, hub) {
  if (!roomSession) {
    return roomSession;
  }

  return {
    ...roomSession,
    roomResourceLimits: resolveRoomResourceLimits({
      subscriptionLimits: roomSession.limits,
      config: configManager.config,
      roomSettings: hub
    })
  };
}

async function connectDialogToHub({
  hub,
  scene,
  clientId,
  roomSession,
  forceTcp,
  forceTurn,
  iceTransportPolicy,
  dialogEndpoint
}) {
  const effectiveRoomSession = withResolvedRoomResourceLimits(
    roomSession || { state: "legacy_active", peerMode: "active" },
    hub
  );
  const shouldRequireSessionGrant = effectiveRoomSession.state !== "legacy_active";
  let currentRoomSession = effectiveRoomSession;

  logRtcSfuRecovery("dialog-connect-to-hub:start", {
    roomId: hub?.hub_id,
    clientId,
    session: summarizeRtcSfuRoomSession(currentRoomSession),
    shouldRequireSessionGrant,
    hasDialogEndpointOverride: Boolean(dialogEndpoint)
  });

  if (shouldRequireSessionGrant && !effectiveRoomSession.allocationGrant) {
    logRtcSfuRecovery("dialog-connect-to-hub:missing-grant", {
      roomId: hub?.hub_id,
      session: summarizeRtcSfuRoomSession(currentRoomSession)
    });
    throw new Error("RTC SFU room session did not include an allocation grant.");
  }

  let pendingRoomSessionRequest = null;
  const resolveRoomSession = shouldRequireSessionGrant
    ? async ({ isCurrent = () => true } = {}) => {
        const previousRoomSession = APP.rtcSfuRoomSession;
        let request = pendingRoomSessionRequest;
        if (!request || request.session !== previousRoomSession || request.clientId !== clientId) {
          request = {
            session: previousRoomSession,
            clientId,
            promise: requestActiveRtcSfuRoomSession({ roomId: hub.hub_id, clientId })
          };
          pendingRoomSessionRequest = request;
        }
        let nextRoomSession;
        try {
          nextRoomSession = await request.promise;
        } finally {
          if (pendingRoomSessionRequest === request) pendingRoomSessionRequest = null;
        }
        if (!isCurrent() || APP.rtcSfuRoomSession !== previousRoomSession) return null;

        currentRoomSession = withResolvedRoomResourceLimits(nextRoomSession, APP.hub || hub);
        APP.rtcSfuRoomSession = currentRoomSession;

        return currentRoomSession;
      }
    : null;

  const endpoint =
    dialogEndpoint ||
    (await resolveHubDialogEndpoint(hub, clientId, qs, {
      allocationGrant: currentRoomSession.allocationGrant
    }));

  APP.rtcSfuRoomSession = effectiveRoomSession;

  logRtcSfuRecovery("dialog-connect-to-hub:endpoint", {
    roomId: hub?.hub_id,
    endpoint: summarizeRtcSfuEndpoint(endpoint),
    session: summarizeRtcSfuRoomSession(currentRoomSession)
  });

  remountUI({ dialogConnected: false, hasDialogConnectedOnce: hasDialogConnectedForCurrentRoom(APP) });
  APP.dialog.disconnect();

  return APP.dialog.connect({
    serverUrl: endpoint.serverUrl,
    roomId: hub.hub_id,
    serverParams: {
      host: endpoint.host,
      port: endpoint.port,
      turn: endpoint.turn,
      iceServers: endpoint.iceServers || endpoint.ice_servers,
      allocation: endpoint.allocation
    },
    scene,
    clientId,
    forceTcp,
    forceTurn,
    iceTransportPolicy,
    dialogEndpoint: endpoint,
    resolveDialogEndpoint: async ({ onStateChange, isCurrent = () => true } = {}) => {
      const nextRoomSession = resolveRoomSession ? await resolveRoomSession({ isCurrent }) : currentRoomSession;
      if (!isCurrent() || !nextRoomSession) return null;

      return resolveHubDialogEndpoint(APP.hub || hub, clientId, qs, {
        onStateChange,
        allocationGrant: nextRoomSession.allocationGrant
      });
    },
    resolveRoomSession,
    allocationGrant: currentRoomSession.allocationGrant,
    peerMode: currentRoomSession.peerMode,
    roomSessionId: currentRoomSession.roomSessionId,
    reconnectToken: currentRoomSession.reconnectToken,
    roomResourceLimits: currentRoomSession.roomResourceLimits,
    roomMediaQuality: currentRoomSession.roomMediaQuality
  });
}

function updateAvatar(entry, scene) {
  requestAvatarSelection(scene, entry.id, { forceReload: true });
}

// TODO: Find a home for this
// TODO: Naming. Is this an "event bus"?
const events = emitter();
async function handleHubChannelJoined(entryManager, hubChannel, messageDispatch, data, dashboardChannel) {
  const scene = document.querySelector("a-scene");
  const isRejoin = NAF.connection.isConnected();

  if (isRejoin) {
    // Slight hack, to ensure correct presence state we need to re-send the entry event
    // on re-join. Ideally this would be updated into the channel socket state but this
    // would require significant changes to the hub channel events and socket management.
    if (scene.is("entered")) {
      hubChannel.sendEnteredEvent();
    }

    // Send complete sync on phoenix re-join.
    // TODO: We should be able to safely remove this completeSync now that
    //       NAF occupancy is driven from phoenix presence state.
    NAF.connection.entities.completeSync(null, true);
    return;
  }

  if (!configManager.config.avatarNetworking.enabled) {
    hubChannel.allowNAFTraffic(false);
  }

  // Turn off NAF for embeds as an optimization, so the user's browser isn't getting slammed
  // with NAF traffic on load.
  // if (isEmbed) {
  //   hubChannel.allowNAFTraffic(false);
  // }

  const hub = data.hubs[0];

  // Prevent Modify Room configuration from Config Manager
  // if(!configManager.config.voiceChat.enabled
  //   || !configManager.config.textChat.enabled
  //   || !configManager.config.spawnAndMoveMedia.enabled
  //   || !configManager.config.spawnCamera.enabled
  // ) {
  //   hubChannel.channel.push("update_hub", {
  //     name: hub.name,
  //     description: hub.description,
  //     room_size: hub.room_size,
  //     user_data: hub.user_data,
  //     entry_mode: hub.entry_mode,
  //     member_permissions: {
  //       ...hub.member_permissions,
  //       "spawn_camera": configManager.config.spawnCamera.enabled,
  //       "spawn_and_move_media": configManager.config.spawnAndMoveMedia.enabled,
  //       "text_chat": configManager.config.textChat.enabled,
  //       "voice_chat": configManager.config.voiceChat.enabled
  //     }
  //   })
  // }

  if (!hubChannel.can("update_hub") && hub.user_data?.redirect_url) {
    document.location = hub.user_data?.redirect_url;
    return;
  }

  remountUI({
    messageDispatch: messageDispatch,
    onSendMessage: messageDispatch.dispatch,
    onLoaded: () => store.executeOnLoadActions(scene),
    onMediaSearchResultEntrySelected: (entry, selectAction) =>
      scene.emit("action_selected_media_result_entry", { entry, selectAction }),
    onMediaSearchCancelled: entry => scene.emit("action_media_search_cancelled", entry),
    onAvatarSaved: entry => scene.emit("action_avatar_saved", entry)
  });

  scene.addEventListener("action_selected_media_result_entry", async e => {
    const { entry, selectAction } = e.detail;

    if ((selectAction === "use" && entry.type === "avatar") || entry.type === "avatar_listing") {
      updateAvatar(entry, scene);
      return;
    }

    if ((entry.type && entry.type !== "scene_listing" && entry.type !== "scene") || selectAction !== "use") return;
    if (!hubChannel.can("update_hub")) return;

    try {
      await applyRoomDeploymentSelection(dashboardChannel, hubChannel, entry);
    } catch {
      console.warn("Failed to update scene on dashboard");
    }
  });

  // Handle request for user gesture
  scene.addEventListener("2d-interstitial-gesture-required", () => {
    remountUI({
      showInterstitialPrompt: true,
      onInterstitialPromptClicked: () => {
        remountUI({ showInterstitialPrompt: false, onInterstitialPromptClicked: null });
        scene.emit("2d-interstitial-gesture-complete");
      }
    });
  });

  scene.addEventListener(
    "didConnectToNetworkedScene",
    () => {
      if (qsTruthy("newLoader")) {
        loadSavedEntityStates(APP.hubChannel);
        loadLegacyRoomObjects(hub.hub_id);
      } else {
        // Append objects once we are in the NAF room since ownership may be taken.
        const objectsScene = document.querySelector("#objects-scene");
        const objectsUrl = getReticulumFetchUrl(`/${hub.hub_id}/objects.gltf`);
        const objectsEl = document.createElement("a-entity");
        objectsEl.setAttribute("data-room-objects", hub.hub_id);
        objectsEl.setAttribute("gltf-model-plus", {
          src: objectsUrl,
          useCache: false,
          inflate: true
        });

        if (!isBotMode) {
          objectsScene.appendChild(objectsEl);
        }
      }
    },
    { once: true }
  );

  const dialogEndpoint = await resolveHubDialogEndpoint(hub, data.session_id, qs);

  scene.setAttribute("networked-scene", {
    room: hub.hub_id,
    serverURL: dialogEndpoint.serverUrl, // TODO: This is confusing because this is the dialog host and port.
    debug: !!isDebug,
    adapter: "phoenix"
  });

  (async () => {
    while (!scene.components["networked-scene"] || !scene.components["networked-scene"].data) await nextTick();

    const loadEnvironmentAndConnect = () => {
      updateEnvironmentForHub(hub, entryManager);

      scene.addEventListener(
        "adapter-ready",
        ({ detail: adapter }) => {
          adapter.hubChannel = hubChannel;
          adapter.events = events;
          adapter.session_id = data.session_id;
        },
        { once: true }
      );
      scene.components["networked-scene"]
        .connect()
        .then(() => {
          scene.emit("didConnectToNetworkedScene");
        })
        .catch(connectError => {
          onConnectionError(entryManager, connectError);
        });
    };

    try {
      await dashboardChannel.loadPlatformRuntimeHub(hub, { syncSettings: false });
    } catch (error) {
      if (error.status === 404) {
        showDialogConnectErrorScreen(entryManager, ExitReason.notFound);
      } else {
        onConnectionError(entryManager, error);
      }
      return;
    }
    window.APP.hub = hub;
    updateUIForHub(hub, hubChannel);
    scene.emit("hub_updated", { hub });

    loadEnvironmentAndConnect();
    // if (!isEmbed) {
    //   loadEnvironmentAndConnect();
    // } else {
    //   remountUI({
    //     onPreloadLoadClicked: () => {
    //       console.log("Preload has been activated");
    //       hubChannel.allowNAFTraffic(true);
    //       remountUI({ showPreload: false });
    //       loadEnvironmentAndConnect();
    //     }
    //   });
    // }
  })();
}

async function runBotMode(scene, entryManager) {
  const noop = () => {};
  const alwaysFalse = () => false;
  scene.renderer = {
    setAnimationLoop: noop,
    render: noop,
    shadowMap: {},
    vr: { isPresenting: alwaysFalse },
    setSize: noop
  };

  while (!NAF.connection.isConnected()) await nextTick();
  entryManager.enterSceneWhenLoaded(false, false);
}

document.addEventListener("DOMContentLoaded", async () => {
  if (isOAuthModal) {
    return;
  }

  const localBridgeRedirect = await startLocalBridgeRedirectIfHinted();
  if (localBridgeRedirect.status === "redirecting") {
    return;
  }

  await store.initProfile();

  const canvas = document.querySelector(".a-canvas");
  canvas.classList.add("a-hidden");

  if (platformUnsupported()) {
    return;
  }

  const detectedOS = detectOS(navigator.userAgent);
  const browser = detect();
  // HACK - it seems if we don't initialize the mic track up-front, voices can drop out on iOS
  // safari when initializing it later.
  // Seems to be working for Safari >= 16.4. We should revisit this in the future and remove it completely.
  // UPDATE - We permit the user to enter, but we show a warning message to the user.
  if (
    ["iOS", "Mac OS"].includes(detectedOS) &&
    ["safari", "ios"].includes(browser.name) &&
    browser.version < "16.4" &&
    !configManager.config.roomEntryDialog.enterOnAR.enabled
  ) {
    try {
      await (isMobile
        ? withIdleDetectionSuspendedUntilForeground(
            () => navigator.mediaDevices.getUserMedia({ audio: true }),
            "safari-mic-prewarm"
          )
        : navigator.mediaDevices.getUserMedia({ audio: true }));
    } catch (e) {
      setTimeout(() => {
        notificationsCenter.warning(LogMessageType.safariMicTitle, LogMessageType.safariMicMessage);
      }, 1000);
    }
  }

  const hubId = getCurrentHubId();

  const shouldRedirectToSignInPage =
    // Default room won't work if account is required to access
    !configs.feature("default_room_id") &&
    configs.feature("require_account_for_join") &&
    !(store.state.credentials && store.state.credentials.token);
  if (shouldRedirectToSignInPage) {
    document.location = `/?sign_in&sign_in_destination=hub&sign_in_destination_url=${encodeURIComponent(
      document.location.toString()
    )}`;
  }

  const subscriptions = new Subscriptions(hubId);
  APP.subscriptions = subscriptions;
  subscriptions.register();

  const scene = document.querySelector("a-scene");
  setupWakeLock(scene);

  await resolveAvatarSrcWithFallback(store.state.profile.avatarId, { store });

  const authChannel = new AuthChannel(store);
  const hubChannel = new HubChannel(store, hubId);
  const dashboardChannel = dashboardChannelSingleton.getInstance(store, hubId);
  window.APP.hubChannel = hubChannel;
  window.APP.dashboardChannel = dashboardChannel;

  const avatarSelectionController = createAvatarSelectionController({
    store,
    dashboardChannel,
    fetchAvatarImpl: fetchAvatar,
    resolveFallbackImpl: ({ workspaceId }) =>
      resolveAvatarFallback({
        workspaceId,
        persistenceApiUrl: configs.PERSISTENCE_API_URL,
        authHeaders: getAuthHeaders
      }),
    persistenceApiUrl: configs.PERSISTENCE_API_URL,
    onChanged: () => notificationsCenter.success(LogMessageType.avatarChanged),
    onApplied: () => scene.emit("avatar_updated"),
    onError: error => console.error("AvatarPersistenceManager: Failed to persist selected avatar", error)
  });
  const onAvatarSelectionRequested = event => {
    void avatarSelectionController.select(event.detail);
  };
  scene.addEventListener(AVATAR_SELECTION_REQUESTED, onAvatarSelectionRequested);
  window.addEventListener("pagehide", event => {
    if (event.persisted) return;
    scene.removeEventListener(AVATAR_SELECTION_REQUESTED, onAvatarSelectionRequested);
    avatarSelectionController.dispose();
  });

  const entryManager = new SceneEntryManager(hubChannel, authChannel, history);
  window.APP.entryManager = entryManager;

  APP.dialog.on(DIALOG_CONNECTION_CONNECTED, () => {
    markDialogConnectedForCurrentRoom(APP);
    updateRtcSfuConnectionState(DIALOG_CONNECTION_STATE.CONNECTED);
    scene.emit("didConnectToDialog");
  });
  APP.dialog.on(DIALOG_CONNECTION_STATE_CHANGED, ({ state }) => {
    handleRtcSfuConnectionStateChange(state, APP.entryManager, scene);
  });
  APP.dialog.on(DIALOG_CONNECTION_ERROR_FATAL, () => {
    showDialogConnectErrorScreen(APP.entryManager);
  });

  const audioSystem = scene.systems["hubs-systems"].audioSystem;
  APP.mediaDevicesManager = new MediaDevicesManager(scene, store, audioSystem);
  APP.mediaDevicesManagerPermissions = new MediaDeviceManagerPermissions(APP.mediaDevicesManager);

  // Guard to prevent concurrent performConditionalSignIn calls
  let isPerformingConditionalSignIn = false;

  const performConditionalSignIn = async (predicate, action, signInMessage, onFailure, signInOptions) => {
    if (predicate()) return action();

    // Prevent concurrent sign-in dialogs
    if (isPerformingConditionalSignIn) {
      console.log("performConditionalSignIn already in progress, skipping");
      return;
    }

    isPerformingConditionalSignIn = true;

    try {
      await handleExitTo2DInterstitial(true, () => remountUI({ showSignInDialog: false }));

      remountUI({
        showSignInDialog: true,
        signInMessage,
        signInOptions,

        onContinueAfterSignIn: async () => {
          try {
            remountUI({ showSignInDialog: false, onContinueAfterSignIn: null });

            // Await one second of sync
            await new Promise(resolve => setTimeout(resolve, 1000));

            let actionError = null;
            if (predicate()) {
              try {
                await action();
              } catch (e) {
                actionError = e;
              }
            } else {
              actionError = new Error("Predicate failed post sign-in");
            }

            if (actionError && onFailure) onFailure(actionError);
            exit2DInterstitialAndEnterVR();
          } finally {
            isPerformingConditionalSignIn = false;
          }
        }
      });
    } catch (error) {
      console.error("Error in performConditionalSignIn:", error);
      isPerformingConditionalSignIn = false;
    }
  };

  window.APP.pinningHelper = new PinningHelper(
    hubChannel,
    authChannel,
    store,
    performConditionalSignIn,
    dashboardChannel,
    scene
  );
  window.APP.lockHelper = new LockHelper(hubChannel, authChannel, store, performConditionalSignIn);

  window.addEventListener("action_create_avatar", () => {
    performConditionalSignIn(
      () => hubChannel.signedIn,
      () =>
        pushHistoryState(history, "overlay", "avatar-creator", {
          create: true,
          avatarId: store.state.profile.avatarId
        }),
      SignInMessages.createAvatar
    );
  });

  scene.addEventListener("scene_media_selected", e => {
    const sceneInfo = e.detail;

    performConditionalSignIn(
      () => hubChannel.can("update_hub"),
      () => hubChannel.updateScene(sceneInfo),
      SignInMessages.changeScene
    );
  });

  scene.addEventListener("hub_updated", async () => {
    if (isLockedDownDemoRoom()) {
      const avatarRig = document.querySelector("#avatar-rig");
      const avatarId = await fetchRandomPlatformPickAvatarId();
      const { avatarSrc } = await resolveAvatarSrcWithFallback(avatarId);
      avatarRig.setAttribute("player-info", { avatarSrc });
    } else {
      if (scene.is("entered")) {
        entryManager._setPlayerInfoFromProfile(true);
      }
    }
  });

  remountUI({
    avatarSelectionController,
    performConditionalSignIn,
    embed: isEmbed,
    showPreload: false
  });
  entryManager.performConditionalSignIn = performConditionalSignIn;
  entryManager.init();

  const linkChannel = new LinkChannel(store);
  window.dispatchEvent(new CustomEvent("hub_channel_ready"));

  const handleEarlyVRMode = () => {
    // If VR headset is activated, refreshing page will fire vrdisplayactivate
    // which puts A-Frame in VR mode, so exit VR mode whenever it is attempted
    // to be entered and we haven't entered the room yet.
    if (scene.is("vr-mode") && !scene.is("vr-entered") && !isMobileVR) {
      scene.emit("exit-vr");
      return true;
    }

    return false;
  };
  remountUI({ availableVREntryTypes: ONLY_SCREEN_AVAILABLE, checkingForDeviceAvailability: true });
  const availableVREntryTypesPromise = getAvailableVREntryTypes();
  scene.addEventListener("enter-vr", () => {
    if (handleEarlyVRMode()) return true;

    if (isMobileVR) {
      // Optimization, stop drawing UI if not visible
      remountUI({ hide: true });
    }

    document.body.classList.add("vr-mode");

    availableVREntryTypesPromise.then(availableVREntryTypes => {
      // Don't stretch canvas on cardboard, since that's drawing the actual VR view :)
      if ((!isMobile && !isMobileVR) || availableVREntryTypes.cardboard !== VR_DEVICE_AVAILABILITY.yes) {
        document.body.classList.add("vr-mode-stretch");
      }
    });
  });
  handleEarlyVRMode();

  // HACK A-Frame 0.9.0 seems to fail to wire up vrdisplaypresentchange early enough
  // to catch presentation state changes and recognize that an HMD is presenting on startup.
  window.addEventListener(
    "vrdisplaypresentchange",
    () => {
      if (scene.is("vr-entered")) return;
      if (scene.is("vr-mode")) return;

      const device = AFRAME.utils.device.getVRDisplay();

      if (device && device.isPresenting) {
        if (!scene.is("vr-mode")) {
          console.warn("Hit A-Frame bug where VR display is presenting but A-Frame has not entered VR mode.");
          scene.enterVR();
        }
      }
    },
    { once: true }
  );

  scene.addEventListener("exit-vr", () => {
    document.body.classList.remove("vr-mode");
    document.body.classList.remove("vr-mode-stretch");

    remountUI({ hide: false });

    // HACK: Oculus browser pauses videos when exiting VR mode, so we need to resume them after a timeout.
    if (/OculusBrowser/i.test(window.navigator.userAgent)) {
      document.querySelectorAll("[media-video]").forEach(m => {
        const videoComponent = m.components["media-video"];

        if (videoComponent) {
          videoComponent._ignorePauseStateChanges = true;

          setTimeout(() => {
            const video = videoComponent.video;

            if (video && video.paused && !videoComponent.data.videoPaused) {
              video.play();
            }

            videoComponent._ignorePauseStateChanges = false;
          }, 1000);
        }
      });
    }
  });

  registerNetworkSchemas();

  remountUI({
    authChannel,
    hubChannel,
    dashboardChannel,
    linkChannel,
    subscriptions,
    enterScene: entryManager.enterScene.bind(entryManager),
    enterSceneInVR: entryManager.enterInVR.bind(entryManager),
    exitScene: reason => {
      entryManager.exitScene();
      remountUI({ roomUnavailableReason: reason || ExitReason.exited });
    }
  });

  scene.addEventListener("leave_room_requested", event => {
    logRtcSfuRecovery("room:leave", { roomId: window.APP?.hub?.hub_id });
    entryManager.exitScene();

    const destinationUrl = configs.destinationUrl(window.APP?.hub);
    const roomUnavailableReason = event.detail?.roomUnavailableReason || ExitReason.left;

    remountUI({ roomUnavailableReason, leaveRoomUrl: destinationUrl });
  });

  scene.addEventListener("hub_closed", () => {
    scene.exitVR();
    entryManager.exitScene();
    remountUI({ roomUnavailableReason: ExitReason.closed });
  });

  scene.addEventListener("action_camera_recording_started", () => hubChannel.beginRecording());
  scene.addEventListener("action_camera_recording_ended", () => hubChannel.endRecording());

  if (qs.get("required_version") && process.env.BUILD_VERSION) {
    const buildNumber = process.env.BUILD_VERSION.split(" ", 1)[0]; // e.g. "123 (abcd5678)"

    if (qs.get("required_version") !== buildNumber) {
      remountUI({ roomUnavailableReason: ExitReason.versionMismatch });
      setTimeout(() => document.location.reload(), 5000);
      entryManager.exitScene();
      return;
    }
  }

  getReticulumMeta().then(reticulumMeta => {
    if (
      qs.get("required_ret_version") &&
      (qs.get("required_ret_version") !== reticulumMeta.version || qs.get("required_ret_pool") !== reticulumMeta.pool)
    ) {
      remountUI({ roomUnavailableReason: ExitReason.versionMismatch });
      setTimeout(() => document.location.reload(), 5000);
      entryManager.exitScene();
      return;
    }
  });

  availableVREntryTypesPromise.then(async availableVREntryTypes => {
    if (isMobileVR) {
      remountUI({
        availableVREntryTypes,
        forcedVREntryType: qsVREntryType || "vr",
        checkingForDeviceAvailability: false
      });

      if (/Oculus/.test(navigator.userAgent) && "getVRDisplays" in navigator) {
        // HACK - The polyfill reports Cardboard as the primary VR display on startup out ahead of
        // Oculus Go on Oculus Browser 5.5.0 beta. This display is cached by A-Frame,
        // so we need to resolve that and get the real VRDisplay before entering as well.
        const displays = await navigator.getVRDisplays();
        const vrDisplay = displays.length && displays[0];
        AFRAME.utils.device.getVRDisplay = () => vrDisplay;
      }
    } else {
      const hasVREntryDevice =
        availableVREntryTypes.cardboard !== VR_DEVICE_AVAILABILITY.no ||
        availableVREntryTypes.generic !== VR_DEVICE_AVAILABILITY.no ||
        availableVREntryTypes.daydream !== VR_DEVICE_AVAILABILITY.no;

      remountUI({
        availableVREntryTypes,
        forcedVREntryType: qsVREntryType || (!hasVREntryDevice ? "2d" : null),
        checkingForDeviceAvailability: false
      });
    }
  });

  const environmentScene = document.querySelector("#environment-scene");
  environmentScene.addEventListener(
    "model-loaded",
    () => {
      // Replace renderer with a noop renderer to reduce bot resource usage.
      if (isBotMode) {
        runBotMode(scene, entryManager);
      }
    },
    { once: true }
  );

  environmentScene.addEventListener("model-loaded", ({ target, detail: { model, src } }) => {
    // Child models bubble this event before the environment has finished inflating.
    if (target.parentNode !== environmentScene) return;

    // A transition can request its destination before the placeholder's event bubbles here.
    if (src !== target.components["gltf-model-plus"]?.lastSrc) return;

    if (!scene.is("entered")) {
      setupLobbyCamera();
    }

    // This will be run every time the environment is changed (including the first load.)
    remountUI({ environmentSceneLoaded: true });
    scene.emit("environment-scene-loaded", model);

    for (const modelEl of environmentScene.children) {
      addAnimationComponents(modelEl);
    }
  });

  // Socket disconnects on refresh but we don't want to show exit scene in that scenario.
  let isReloading = false;
  let wasKickedByServer = false;
  window.addEventListener("beforeunload", () => (isReloading = true));

  const socket = await connectToReticulum(isDebug);

  const connectToDialog = roomSession =>
    connectDialogToHub({
      hub: APP.hub,
      scene,
      clientId: socket.params().session_id || APP.getString(localClientID),
      roomSession,
      forceTcp: qs.get("force_tcp"),
      forceTurn: qs.get("force_turn"),
      iceTransportPolicy: qs.get("force_tcp") || qs.get("force_turn") ? "relay" : "all"
    });

  APP.connectToDialog = connectToDialog;
  remountUI({ connectToDialog });

  socket.onClose(e => {
    // Keep the close reason fallback for older servers; current servers send a kicked channel event
    // before closing the session socket.
    const NORMAL_CLOSURE = 1000;

    if (e.code === NORMAL_CLOSURE && !isReloading) {
      const roomUnavailableReason =
        wasKickedByServer || e.reason === "kicked" ? ExitReason.kicked : ExitReason.disconnected;
      entryManager.exitScene();
      remountUI({ roomUnavailableReason });
    }
  });

  // Reticulum global channel
  APP.retChannel = socket.channel(`ret`, { hub_id: hubId });
  APP.retChannel
    .join()
    .receive("ok", data => {
      subscriptions.setVapidPublicKey(data.vapid_public_key);
    })
    .receive("error", res => {
      subscriptions.setVapidPublicKey(null);
      console.error(res);
    });

  const pushSubscriptionEndpoint = await subscriptions.getCurrentEndpoint();

  APP.hubChannelParamsForPermsToken = permsToken => {
    return createHubChannelParams({
      profile: store.state.profile,
      pushSubscriptionEndpoint,
      permsToken,
      isMobile,
      isMobileVR,
      isEmbed,
      hubInviteId: qs.get("invitation_id") || qs.get("hub_invite_id"),
      authToken: store.state.credentials && store.state.credentials.token,
      runtimeModeratorGrant: getRuntimeModeratorGrant()
    });
  };

  const migrateToNewReticulumServer = async ({ ret_version, ret_pool }, shouldAbandonMigration) => {
    const didMatchMeta = await tryGetMatchingMeta({ ret_version, ret_pool }, shouldAbandonMigration);
    if (!didMatchMeta) {
      console.error(`[reconnect] Failed to reconnect. Did not get meta for v${ret_version} on ${ret_pool}.`);
      return;
    }

    const oldSocket = APP.retChannel.socket;
    const socket = await connectToReticulum(isDebug, oldSocket.params());
    APP.retChannel = await migrateChannelToSocket(APP.retChannel, socket);
    await hubChannel.migrateToSocket(socket, APP.hubChannelParamsForPermsToken());
    authChannel.setSocket(socket);
    linkChannel.setSocket(socket);

    // Disconnect old socket after a delay to ensure this user is always registered in presence.
    await sleep(10000);
    oldSocket.teardown();
  };

  const onRetDeploy = (function () {
    let pendingNotification = null;
    const hasPendingNotification = function () {
      return !!pendingNotification;
    };

    const handleNextMessage = (function () {
      let isLocked = false;
      return async function handleNextMessage() {
        if (isLocked || !pendingNotification) return;

        isLocked = true;
        const currentNotification = Object.assign({}, pendingNotification);
        pendingNotification = null;
        try {
          await migrateToNewReticulumServer(currentNotification, hasPendingNotification);
        } catch {
          //
        } finally {
          isLocked = false;
          handleNextMessage();
        }
      };
    })();

    return function onRetDeploy(deployNotification) {
      // If for some reason we receive multiple deployNotifications, only the
      // most recent one matters. The rest can be overwritten.
      pendingNotification = deployNotification;
      handleNextMessage();
    };
  })();

  APP.retChannel.on("notice", data => {
    if (data.event === "ret-deploy") {
      onRetDeploy(data);
    }
  });

  const messageDispatch = new MessageDispatch(scene, entryManager, hubChannel, remountUI, mediaSearchStore);
  APP.messageDispatch = messageDispatch;
  document.getElementById("avatar-rig").messageDispatch = messageDispatch;
  APP.dialog.on(DIALOG_CHAT_MESSAGE_CREATED, message => {
    logRtcSfuRecovery("chat:notification", {
      roomId: APP.hub?.hub_id,
      message: summarizeDialogChatMessage(message)
    });
    messageDispatch.receive(buildDialogChatPresenceEntry(message, hubChannel));
  });

  const oauthFlowPermsToken = Cookies.get(OAUTH_FLOW_PERMS_TOKEN_KEY);
  if (oauthFlowPermsToken) {
    Cookies.remove(OAUTH_FLOW_PERMS_TOKEN_KEY);
  }
  const hubPhxChannel = socket.channel(`hub:${hubId}`, APP.hubChannelParamsForPermsToken(oauthFlowPermsToken));
  hubChannel.channel = hubPhxChannel;

  hubPhxChannel.on("kicked", () => {
    wasKickedByServer = true;
    entryManager.exitScene();
    remountUI({ roomUnavailableReason: ExitReason.kicked });
  });

  hubChannel.presence = new Presence(hubPhxChannel);
  const { rawOnJoin, rawOnLeave } = denoisePresence(presenceEventsForHub(events));
  hubChannel.presence.onJoin(rawOnJoin);
  hubChannel.presence.onLeave(rawOnLeave);
  hubChannel.presence.onSync(() => {
    events.trigger(`hub:sync`, { presence: hubChannel.presence });
  });

  const syncNAFHelper = new SyncNAFHelper(hubChannel, events);
  APP.syncNAFHelper = syncNAFHelper;

  events.on(`hub:join`, ({ key, meta }) => {
    scene.emit("presence_updated", {
      sessionId: key,
      profile: meta.profile,
      roles: meta.roles,
      permissions: meta.permissions,
      streaming: meta.streaming,
      recording: meta.recording,
      hand_raised: meta.hand_raised,
      typing: meta.typing
    });
  });
  events.on(`hub:join`, ({ key, meta }) => {
    if (
      APP.hideHubPresenceEvents ||
      key === hubChannel.channel.socket.params().session_id ||
      hubChannel.presence.list().length > NOISY_OCCUPANT_COUNT
    ) {
      return;
    }
    messageDispatch.receive({
      type: "join",
      presence: meta.presence,
      name: meta.profile.displayName
    });
  });

  events.on(`hub:leave`, ({ meta }) => {
    if (APP.hideHubPresenceEvents || hubChannel.presence.list().length > NOISY_OCCUPANT_COUNT) {
      return;
    }
    messageDispatch.receive({
      type: "leave",
      name: meta.profile.displayName
    });
  });

  events.on(`hub:change`, ({ key, previous, current }) => {
    if (
      previous.presence === current.presence ||
      current.presence !== "room" ||
      key === hubChannel.channel.socket.params().session_id
    ) {
      return;
    }

    messageDispatch.receive({
      type: "entered",
      presence: current.presence,
      name: current.profile.displayName
    });
  });
  /*   events.on(`hub:change`, ({ previous, current }) => {
        if (previous.profile.displayName !== current.profile.displayName) {
          messageDispatch.receive({
            type: "display_name_changed",
            oldName: previous.profile.displayName,
            newName: current.profile.displayName
          });
        }
      }); */
  events.on(`hub:change`, ({ key, current }) => {
    scene.emit("presence_updated", {
      sessionId: key,
      profile: current.profile,
      roles: current.roles,
      permissions: current.permissions,
      streaming: current.streaming,
      recording: current.recording,
      hand_raised: current.hand_raised,
      typing: current.typing
    });
  });

  // We need to be able to wait for initial presence syncs across reconnects and socket migrations,
  // so we create this object in the outer scope and assign it a new promise on channel join.
  const presenceSync = {
    promise: null,
    resolve: null
  };
  events.on("hub:sync", () => {
    presenceSync.resolve && presenceSync.resolve();
  });
  events.on(`hub:sync`, () => {
    APP.hideHubPresenceEvents = false;
  });
  events.on(`hub:sync`, updateVRHudPresenceCount);
  events.on(`hub:sync`, ({ presence }) => {
    updateSceneCopresentState(presence, scene);
  });
  events.on(`hub:sync`, async ({ presence }) => {
    const roomUnavailableReason = await getRoomUnavailableReasonForEntry(hubChannel, uiProps.hub, store);

    if (roomUnavailableReason) {
      APP.entryManager.exitScene();
      remountUI({ roomUnavailableReason });
    } else {
      remountUI({
        sessionId: socket.params().session_id,
        presences: presence.state,
        entryDisallowed: false
      });
    }
  });

  listenForNetworkMessages(hubPhxChannel, events);
  hubPhxChannel
    .join()
    .receive("ok", async data => {
      const hub = data.hubs[0];

      const interval = setInterval(async () => {
        if (!hub || typeof hub !== "object") {
          return;
        }

        clearInterval(interval);

        window.APP.hub = hub;

        // Check if the user_data.subdomain is set, if so, check that the current url includes it, if not, redirect to the subdomain keeping the path
        if (hub?.user_data?.subdomain) {
          const currentUrl = new URL(window.location.href);
          const subdomain = hub.user_data.subdomain;
          if (window.location.href.indexOf(subdomain) === -1) {
            return (window.location.href = subdomain + currentUrl.pathname + currentUrl.search);
          }
        }

        const roomUnavailableReason = await getRoomUnavailableReasonForEntry(hubChannel, hub, store);

        if (roomUnavailableReason) {
          APP.entryManager.exitScene();
          remountUI({ roomUnavailableReason });

          return;
        }

        setLocalClientID(APP.getSid(data.session_id));
        APP.hideHubPresenceEvents = true;
        presenceSync.promise = new Promise(resolve => {
          presenceSync.resolve = resolve;
        });

        socket.params().session_id = data.session_id;
        socket.params().session_token = data.session_token;

        const permsToken = oauthFlowPermsToken || data.perms_token;
        hubChannel.setPermissionsFromToken(permsToken);

        subscriptions.setHubChannel(hubChannel);
        subscriptions.setSubscribed(data.subscriptions.web_push);

        remountUI({
          hubIsBound: data.hub_requires_oauth,
          initialIsFavorited: data.subscriptions.favorites
        });

        presenceSync.promise;
        handleHubChannelJoined(entryManager, hubChannel, messageDispatch, data, dashboardChannel).catch(
          connectError => {
            onConnectionError(entryManager, connectError);
          }
        );
      }, 100);
    })
    .receive("error", res => {
      if (res.reason === "closed") {
        entryManager.exitScene();
        remountUI({ roomUnavailableReason: ExitReason.closed });
      } else if (res.reason === "oauth_required") {
        entryManager.exitScene();
        remountUI({ oauthInfo: res.oauth_info, showOAuthScreen: true });
      } else if (res.reason === "join_denied") {
        entryManager.exitScene();
        remountUI({ roomUnavailableReason: ExitReason.denied });
      } else if (res.reason === "not_found") {
        entryManager.exitScene();
        remountUI({ roomUnavailableReason: ExitReason.notFound });
      }

      console.error(res);
    });

  hubPhxChannel.on("message", ({ session_id, type, body, from }) => {
    const getAuthor = () => {
      const userInfo = hubChannel.presence.state[session_id];
      if (from) {
        return from;
      } else if (userInfo) {
        return userInfo.metas[0].profile.displayName;
      } else {
        return "Mystery user";
      }
    };

    const name = getAuthor();
    const maySpawn = scene.is("entered");

    const incomingMessage = {
      name,
      type,
      body,
      maySpawn,
      sessionId: session_id,
      sent: session_id === socket.params().session_id
    };

    if (scene.is("vr-mode")) {
      createInWorldLogMessage(incomingMessage);
    }

    messageDispatch.receive(incomingMessage);
  });

  hubPhxChannel.on("hub_refresh", ({ session_id, hubs, stale_fields }) => {
    // Pull from window the smoothTransition variable, store it on a variable and remove it from window
    const smoothTransition = window.smoothTransition;
    delete window.smoothTransition;

    const hub = hubs[0];
    const userInfo = hubChannel.presence.state[session_id];
    const displayName = (userInfo && userInfo.metas[0].profile.displayName) || "API";

    window.APP.hub = hub;
    updateUIForHub(hub, hubChannel);

    if (
      stale_fields.includes("scene") ||
      stale_fields.includes("scene_listing") ||
      stale_fields.includes("default_environment_gltf_bundle_url")
    ) {
      const fader = document.getElementById("viewing-camera").components["fader"];

      if (smoothTransition) {
        scene.emit("reset_scene");
        updateEnvironmentForHub(hub, entryManager, smoothTransition);
      } else {
        fader.fadeOut().then(() => {
          scene.emit("reset_scene");
          scene.emit("scene-loading");
          updateEnvironmentForHub(hub, entryManager);
        });
      }

      const sceneName = hub.scene ? hub.scene.name : "a custom URL";

      messageDispatch.receive({
        type: "scene_changed",
        name: displayName,
        sceneName
      });
    }

    if (stale_fields.includes("member_permissions")) {
      hubChannel.fetchPermissions();
    }

    if (stale_fields.includes("name")) {
      const titleParts = document.title.split(" | "); // Assumes title has | trailing site name
      titleParts[0] = hub.name;
      document.title = titleParts.join(" | ");

      if (hub.description) {
        document.description = hub.description;
      }

      // Re-write the slug in the browser history
      const pathParts = history.location.pathname.split("/");
      const oldSlug = pathParts[1];
      const { search, state } = history.location;
      const pathname = history.location.pathname.replace(`/${oldSlug}`, `/${hub.slug}`);

      history.replace({ pathname, search, state });

      messageDispatch.receive({
        type: "hub_name_changed",
        name: displayName,
        hubName: hub.name
      });
    }

    if (hub.entry_mode === "deny") {
      scene.emit("hub_closed");
    }

    scene.emit("hub_updated", { hub });
  });

  hubPhxChannel.on("host_changed", ({ host, port, turn, iceServers, ice_servers }) => {
    const dialogEndpoint = resolveDialogEndpoint({ host, port, turn, iceServers: iceServers || ice_servers }, qs);

    logRtcSfuRecovery("hub-host-changed", {
      host,
      port,
      hasTurn: Boolean(turn?.enabled),
      hasIceServers: Boolean((iceServers || ice_servers)?.length),
      dialogEndpoint: summarizeRtcSfuEndpoint(dialogEndpoint),
      hasProtoo: Boolean(APP.dialog._protoo)
    });

    // Platform admission owns grant refresh and endpoint recovery. Reticulum
    // discovery must not replay a consumed reservation or race a portal join.
    if (
      !APP.dialog._protoo ||
      APP.roomTransition?.pending ||
      (APP.rtcSfuRoomSession && APP.rtcSfuRoomSession.state !== "legacy_active") ||
      APP.dialog._dialogEndpoint?.usingRtcSfuOrchestrator
    ) {
      return;
    }

    connectDialogToHub({
      hub: {
        ...APP.hub,
        host,
        port,
        turn,
        iceServers: iceServers || ice_servers
      },
      scene,
      roomSession: APP.rtcSfuRoomSession,
      clientId: APP.getString(localClientID),
      forceTcp: qs.get("force_tcp"),
      forceTurn: qs.get("force_turn"),
      iceTransportPolicy: qs.get("force_tcp") || qs.get("force_turn") ? "relay" : "all",
      dialogEndpoint
    }).catch(connectError => {
      onConnectionError(entryManager, connectError);
    });
  });

  hubPhxChannel.on("permissions_updated", () => hubChannel.fetchPermissions());

  hubPhxChannel.on("mute", ({ session_id }) => {
    if (session_id === NAF.clientId) {
      APP.mediaDevicesManager.micEnabled = false;
    }
  });

  authChannel.setSocket(socket);
  linkChannel.setSocket(socket);
});
